export default "__VITE_ASSET__e151a520__"